/* eslint-disable indent */
/* eslint-disable import/namespace */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Svg } from '@bvt-atoms';
import './POIGetTable.scss';
import * as BvtIcons from 'bvt-icon';
import _ from 'lodash';
import { generateUUID } from '@bvt-utils';

export default function POIGetTable(props) {
  const { data, gridID } = props;
  const [show, setShow] = useState(true);
  const [toggleSubTotal, setToggleSubTotal] = useState(false);

  const totalSubTotal = Object.keys(data)
    ?.map((item) => data?.[item])?.[0]
    ?.results?.map((j) => j?.tot)
    ?.reduce((a, b) => a + b);

  return (
    <div className='poigettable'>
      <div className='poigettable__top-section'>
        {/* TITLE */}
        <div className='poigettable__title-section'>
          <Svg className='poigettable__title-info-svg' src='ic-info' />
          <span className='poigettable__title-text'>POI Get</span>
        </div>
        {/* GRID INFO */}
        <div className='poigettable__grid-section'>
          Grid <span className='poigettable__gridid'>{gridID}</span>
        </div>
      </div>

      {Object.keys(data).length > 0 &&
        Object.keys(data).map((item) => {
          return (
            <div className='poigettable__mid-section' key={generateUUID()}>
              {/* TABLE HEADER */}
              <div
                className='poigettable__table-header'
                onClick={() => setShow(!show)}
              >
                <div className='poigettable__table-header-title'>{item}</div>
                <div style={{ display: 'flex' }}>
                  <span
                    style={{
                      color: 'white',
                      marginRight: '0.75rem',
                      marginTop: 'auto',
                    }}
                  >
                    {totalSubTotal} POI
                  </span>
                  <Svg
                    className='poigettable__title-info-svg'
                    src={show ? 'ic-arrow-up' : 'ic-arrow-down'}
                  />
                </div>
              </div>
              {/* TABLE TITLE */}
              <div style={{ display: show ? 'block' : 'none' }}>
                {/* TITLE */}
                <div className='poigettable__table-title-container'>
                  <div className='poigettable__table-title-container--left'>
                    <div style={{ marginRight: '1.125rem' }}>Icon</div>
                    <div>Type</div>
                  </div>
                  <div className='poigettable__table-title-container--right'>
                    <div
                      className='poigettable__table-data-right'
                      onClick={() => {
                        data[item].results = _.orderBy(
                          data[item].results,
                          ['tot'],
                          [toggleSubTotal ? 'asc' : 'desc']
                        );
                        setToggleSubTotal((prev) => !prev);
                      }}
                    >
                      <div className='poigettable__icon'>
                        <svg
                          height='0.5rem'
                          viewBox='0 0 10.227 7.7'
                          width='1rem'
                        >
                          <path
                            d='M5.9,1.858a1.75,1.75,0,0,1,2.734,0L12,6.058A1.75,1.75,0,0,1,10.63,8.9H3.911A1.75,1.75,0,0,1,2.544,6.058Z'
                            fill={toggleSubTotal ? '#007e75' : '#caced5'}
                            transform='translate(-2.157 -1.202)'
                          />
                        </svg>
                        <svg
                          height='0.5rem'
                          viewBox='0 0 10.227 7.7'
                          width='1rem'
                        >
                          <path
                            d='M3.747.657a1.75,1.75,0,0,1,2.734,0l3.36,4.2A1.75,1.75,0,0,1,8.473,7.7H1.754A1.75,1.75,0,0,1,.387,4.857Z'
                            fill={!toggleSubTotal ? '#007e75' : '#caced5'}
                            transform='translate(10.227 7.7) rotate(180)'
                          />
                        </svg>
                      </div>
                      <div>Sub Total</div>
                    </div>
                  </div>
                </div>
                {/* DATA */}
                {data[item]?.results?.length > 0
                  ? data[item]?.results?.map((ctx) => {
                      const Icon =
                        BvtIcons[ctx?.icon_sub_category] !== undefined
                          ? BvtIcons[ctx.icon_sub_category]
                          : BvtIcons.DefaultPoi;
                      return (
                        <div
                          className='poigettable__table-data-container'
                          key={generateUUID()}
                        >
                          <div className='poigettable__table-data-container--left'>
                            <Icon height='1.5rem' width='1.5rem' />
                            <div>{ctx.nama_sub_kategori}</div>
                          </div>
                          <div className='poigettable__table-data-container--right'>
                            <div
                              style={{
                                textAlign: 'right',
                                marginRight: '1.125rem',
                              }}
                            >
                              {ctx.tot}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : ''}
              </div>
            </div>
          );
        })}

      <div className='poigettable__total-box'>Total ({totalSubTotal})</div>
    </div>
  );
}

POIGetTable.defaultProps = {
  gridID: 1405448,
  title: 'Medical',
};

POIGetTable.propTypes = {
  data: PropTypes.object,
  gridID: PropTypes.number,
  title: PropTypes.string,
};
